import React, { useContext, useEffect, useState } from "react";
import { SessionContext } from "../SessionContext";
import supabase from "../utils/supabase";
import { useNavigate } from "react-router-dom";
import { FiLogOut, FiEdit } from "react-icons/fi";
import { IoSettingsOutline } from "react-icons/io5";
import { MdVerified, MdPending } from "react-icons/md"; // Add MdPending import
import { HashLoader } from "react-spinners";
import useUserStore from "../store/userStore";
import getAvatarUrl from "../utils/dicebear";
const Profile = () => {
  const session = useContext(SessionContext);
  const navigate = useNavigate();
  const userData = useUserStore((state) => state.userData);
  const clearUserData = useUserStore((state) => state.clearUserData);

  useEffect(() => {
    if (!session) {
      navigate("/signin");
    }
  }, [session, navigate]);

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (!error) {
      clearUserData();
      navigate("/signin");
    }
  };

  const getVerificationButton = () => {
    if (userData?.is_verified === "pending") {
      return (
        <button
          disabled
          className="flex-1 sm:flex-none min-w-[120px] flex items-center justify-center gap-2 px-3 sm:px-4 py-2 bg-yellow-100 text-yellow-700 rounded-lg cursor-not-allowed text-sm sm:text-base"
        >
          <HashLoader color="#0072ff" size={20} />
          <span>Verification Pending</span>
        </button>
      );
    }

    return (
      <button
        className="flex-1 sm:flex-none min-w-[120px] flex items-center justify-center gap-2 px-3 sm:px-4 py-2 bg-[#0072ff] text-white rounded-lg hover:bg-[#0052cc] transition-colors text-sm sm:text-base"
        onClick={() => navigate("/userdetailsverify")}
      >
        <MdVerified className="w-5 h-5 shrink-0" />
        <span>Get Verified</span>
      </button>
    );
  };

  return (
    <div className="page nav-exists">
      <div className="max-w-4xl mx-auto p-4 sm:p-6">
        <div className="bg-white rounded-xl shadow-lg p-4 sm:p-8">
          {/* Profile Header */}
          <div className="flex flex-col items-center mb-8">
            <img
              src={getAvatarUrl(userData?.name)}
              alt="Profile"
              className="w-32 h-32 rounded-full mb-4 bg-gray-100"
            />
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold">
                {userData?.name || "Loading..."}
              </h1>
              {userData?.is_verified === "true" && (
                <MdVerified className="text-blue-500 w-6 h-6" />
              )}
            </div>
            <p className="text-gray-600">{userData?.role || "Role not set"}</p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8">
            {getVerificationButton()}

            {/* Settings Button */}
            <button
              className="flex-1 sm:flex-none min-w-[120px] flex items-center justify-center gap-2 px-3 sm:px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors text-sm sm:text-base"
              onClick={() => navigate("/inference")}
            >
              <IoSettingsOutline className="w-5 h-5 shrink-0" />
              <span>Settings</span>
            </button>

            {/* Edit Profile Button */}
            <button
              className="flex-1 sm:flex-none min-w-[120px] flex items-center justify-center gap-2 px-3 sm:px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors text-sm sm:text-base"
              onClick={() => navigate("/userdetailsverify")}
            >
              <FiEdit className="w-5 h-5 shrink-0" />
              <span>Edit Profile</span>
            </button>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="flex-1 sm:flex-none min-w-[120px] flex items-center justify-center gap-2 px-3 sm:px-4 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors text-sm sm:text-base"
            >
              <FiLogOut className="w-5 h-5 shrink-0" />
              <span>Logout</span>
            </button>
          </div>

          {/* User Info */}
          <div className="space-y-4">
            <div className="border-t border-gray-200 pt-4">
              <h2 className="text-lg font-semibold mb-2">Contact</h2>
              <p className="text-gray-600">{session?.user?.email}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
